import React from "react";

// Desktop sidebar: name/role, quick bio + stats, the "Experience" company
// list (home page only, used for scroll-to-section navigation), and the
// About / Contact links at the bottom. Hidden entirely on the case-study
// page and on mobile via CSS.
function Sidebar({
  page,
  companies,
  activeCompany,
  onNavigateHome,
  onCompanyClick,
  onNavigate,
}) {
  const showCompanyNav = page === "home";

  return (
    <div className="sidebar">
      <div onClick={onNavigateHome}>
        <h2 className="s-name">
          Brann
          <br />
          Khattiyanont
        </h2>
      </div>
      {/* <div className="s-role">UX Designer</div> */}
      <div className="s-bio">Designed for people. Built for business.</div>

      <p style={{ color: "#1a1a1a", fontSize: "18px" }}>8+</p>
      <p
        style={{
          color: "#888",
          fontSize: "12px",
          marginTop: "2px",
          fontWeight: 300,
        }}
      >
        Years bridging physical systems and scalable digital ecosystems.
      </p>
      <p style={{ color: "#1a1a1a", marginTop: "8px", fontSize: "18px" }}>6</p>
      <p
        style={{
          color: "#888",
          fontSize: "12px",
          marginTop: "2px",
          fontWeight: 300,
        }}
      >
        Products shipped end-to-end from strategy to code this year
      </p>
      <p style={{ color: "#1a1a1a", marginTop: "8px", fontSize: "18px" }}>3</p>
      <p
        style={{
          color: "#888",
          fontSize: "12px",
          marginTop: "2px",
          fontWeight: 300,
        }}
      >
        Unique design systems architected and maintained.
      </p>

      <div className="s-div" />

      {showCompanyNav && (
        <div id="co-nav-section">
          <div className="s-lbl">Experience</div>
          <div id="co-nav">
            {companies.map((co, ci) => (
              <div
                key={co.id}
                className={"s-co" + (ci === activeCompany ? " active" : "")}
                onClick={() => onCompanyClick(ci)}
              >
                <div className="s-co-dot" />
                <div className="s-co-name">{co.name}</div>
                <div className="s-co-count">{co.projects.length}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="sb-nav">
        <div
          className={"sb-nav-link" + (page === "about" ? " active" : "")}
          onClick={() => onNavigate("about")}
        >
          About me
        </div>
        {/* <div
          className={"sb-nav-link" + (page === "contact" ? " active" : "")}
          onClick={() => onNavigate("contact")}
        >
          Contact <span>↗</span>
        </div> */}
        <div className={"sb-nav-link" + (page === "about" ? " active" : "")}>
          <a
            className="sb-ext-link"
            href="/BrannKhattiyanont_Resume.pdf"
            target="_blank"
          >
            Resume ↓
          </a>
        </div>
      </div>
      <div className="sb-footer">
        <p>©2026 Bannawit Khattiyanont</p>
      </div>
    </div>
  );
}

export default Sidebar;
